// extracted by mini-css-extract-plugin
export default {"container":"PageButtons_container__s-vOX","alignBottom":"PageButtons_alignBottom__B6qI4"};